import type { ReactNode } from "react";
import "./AreaContainer.css";

export const AreaContainer = ({ children }: { children?: ReactNode }) => {
    return <div className="area-container">{children}</div>;
};
